import React from "react";
import { Container, Label } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import FlowerIcon from "../../Icons/FlowerIcon";
import { findMatchRGB } from "../../helpers/utilis";

const cntStyle = css`
  flex-direction: column;
  align-items: center;
`;
const centerAlign = css`
  align-items: center;
`;
const fontColorSize = css`
  color: ${({ theme }) => theme.secColor};
  font-size: 1.2vh;
`;
const justifyStyle = css`
  justify-content: space-evenly;
`;

const ProductLabels = ({ product }) => {
  const matchingObject = findMatchRGB(product.color);

  const labels = [
    { label: "Code", value: product.product_code },
    { label: "Color", value: product.color, showIcon: true },
    {
      label: "Height",
      value:
        product.min_length && product.max_length
          ? `${product.min_length} - ${product.max_length}`
          : "-",
    },
    { label: "Type", value: product.category },
  ];

  return (
    <Container $baseStyle={justifyStyle}>
      {labels.map(({ label, value, showIcon }, index) => (
        <Container key={index} $baseStyle={cntStyle}>
          <Label $baseStyle={fontColorSize}>{label}</Label>
          <Container $baseStyle={centerAlign}>
            {showIcon && matchingObject && (
              <FlowerIcon color={matchingObject} />
            )}
            <Label $baseStyle={fontColorSize}>{value || "-"}</Label>
          </Container>
        </Container>
      ))}
    </Container>
  );
};

export default ProductLabels;
